<template>
	<main-layout class="linksMainDiv">
			<div v-show="!loaded" class="top160" id="slinkHeader"></div>
			<div v-if="loaded" class=" has-text-white">
			
			<div class="">
				<div class="container">
					<img src="/static/logQC.png" width="150" class="is-pulled-right top20 handCursor" @click="navTo('', true)" />
					<br>
					
					<div class=" isPoppins top30 has-text-dark  slinkPageSlinkCont"  >
						<img src="@/assets/img/chevronsY.png" class="right5"  width="40" /><span class="has-text-white">{{slink}}<!-- <span class="has-text-turk">:links</span> --></span>
						<!-- <div class="is-size-5 top5 left30 has-text-light">slink.com/{{slink}}:links</div> -->
					</div>
		
					<div class="pageDescriptionContainer">
							<div  v-show="pageDescription"  class="pageDescription container">
								<b>{{pageDescription}}</b>
							</div>
					</div>
				</div>
			</div>
			
	<!-- 	<div class="linksSubControl">
			<div class="is-size-6 has-text-white">slink.com/<b>{{slink}}:</b></div>
			<div class="is-inline-block">
				<input type="text" class="niceInput slinkPage" placeholder="enter subslink" v-model="enteredSub" @keyup.enter="go(`https://slink.com/${slink}:${enteredSub}`)">
				<button id="goButt" class="button is-yell left-5" @click="go(`https://slink.com/${slink}:${enteredSub}`)">GO</button>
			</div>
		
		</div> -->
			
			
		<div class="container">
				<div class="left20   is-size-4 wideLimitWidth"  >
					<div class="has-text-right top10"> <button class="button is-dark" :class="{'is-yell': sortAlpha}" @click="toggleSort"><i class="fas fa-sort-alpha-down"></i></button></div>
					
					<div v-if="!noShow" class="top3 lpSub main" @click="navTo(slink, true)">
						<div class="columns lpCols2">
							<div class="column lpTitle is-one-third">
								<div class="top10 isPoppins is-size-3"><img src="@/assets/img/chevronsY.png" class="right3"  width="23" /><b>{{slink}}</b></div>
							</div>
							<div class="column is-size-5">
								<div class="lpDescHomeMain">{{description}}</div>
							</div>
						</div>
						<div class="is-size-6 left15 top5 has-text-turk">slink.com/<b>{{slink}}</b></div>
					</div>
	
					<div v-show="noShow" class="">
						<div class="left10 has-text-white">Sorry but there are no public subslinks being shared for this slink.</div>
					</div>
					
					
					<div class="top20" style="border-left: 2px dashed #ffb227">
						<div class="left20 top15 lpSub" v-for="(item, i) in links" :key="i" @click="navTo(item.url)">
							<div class="columns lpCols2">
								<div class="isPoppins lpTitle is-size-5 column is-one-third">
									<b>:{{item.name}}</b>
								</div>
								<div class="column is-size-5 lpLinksDesc">
									<div class="lpDescHomeLinks">{{item.description}}</div>
								</div>
							</div>
							<div class="is-size-6 left10 has-text-turk">slink.com/{{slink}}<b>:{{item.name}}</b></div>
						</div>
					</div>
					
				</div>
				
				<div class="has-text-left left40 has-text-light alignBottom top80 bottom20">
					<div class="is-size-7">Copyright &copy;2024 Slink, Inc.</div>
				</div>
		</div>
		</div>
</main-layout>
</template>

<script>

import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
	components: {
		MainLayout
	},

	data: function(){
		return {
			inited: false,
			slink: '',
			links: [],
			links2: [],
			noShow: true,
			loaded: false,
			description: '',
			pageDescription: '',
			sortAlpha: false,
			enteredSub: ''
		}
	},



	mounted: function(){

		var evt = window.attachEvent || window.addEventListener;
		var checkEvt = window.attachEvent ? 'onbeforeunload' : 'beforeunload';
		evt(checkEvt, function(e) { 
			az.addRemSpinner(false, 'id', 'goButt')
		});

		document.getElementById('navBG').classList.add('hideMe')
		document.getElementById('azFooter').classList.add('hideMe')
		document.getElementById('azSize').style['margin-top'] = 0
		document.getElementById('azSize').style['min-height'] = '100vh'

		this.slink = this.$route.params.slink

		if(this.slink == undefined){
			this.$router.push('/')
		}   else {
			az.addRemSpinner(true, 'id', 'slinkHeader');  
		}
		var self = this;

		function w(d) {

			az.addRemSpinner(false, 'id', 'slinkHeader');
			self.noShow = false
			self.loaded = true
			self.links = d.links
			self.links2 = JSON.parse(JSON.stringify(d.links))
			self.description = d.description
			self.pageDescription = d.pageDescription || 'SlinkPage'
		
		}
		function n(obj) {
			az.addRemSpinner(false, 'id', 'slinkHeader');

			if(obj.message == 'Not Found' || obj.message == 'Forbidden'){
				self.loaded = true
				self.noShow = true
				return
			}

	
			self.$root.showModalOK({message: 'There was en error loading contents.'})
		}


		function init(){
			if(self.slink != undefined){
				self.inited = true
				
				self.$root.apiClient.get(`api/links/${encodeURIComponent(self.slink)}`, {}, w, n)
			}
			
		}

		if(self.$root.doneFederating){
			init();
		}

		AZEventBus.$once('onFederate', msg => {
			if(self.inited == false)
				init();
			});

	},

	methods: {
		navTo: function(url, doProcess){
			az.addRemSpinner(true, 'id', 'goButt')
			if(doProcess){
				window.location.href = `https://${process.env.HOST}/${url}`
			} else {
				window.location.href = url
			}
			setTimeout(function(){
				az.addRemSpinner(false, 'id', 'goButt')
			}, 1000)
		},

		toggleSort: function(){
			this.sortAlpha = !this.sortAlpha
			
			if(this.sortAlpha){
				this.links.sort((a,b) => {
					if(a.name < b.name) { return -1; }
					if(a.name > b.name) { return 1; }
					return 0;
				})
				
			} else {
				this.links = JSON.parse(JSON.stringify(this.links2))
			}
    	},

		go: function(url){
			if(this.enteredSub.length){
				this.navTo(url)
			}
		},



	
	}

}

</script>




// WEBPACK FOOTER //
// src/pages/Links.vue